import {
  buildQueryString,
  useFilteredObjects,
  useObject,
  useObjects,
  usePagination,
} from "../../base";
import { usePaginationCount } from "../../base/hooks/retrieve";
import {
  filterPagination,
  getAll,
  getSingle,
  performFilter,
} from "../store/actions";
import constants from "../store/constants";

export function useInspectionErrandRating(id) {
  const params = {
    storeName: constants.STORE_NAME,
    id: id,
    fetchMethod: getSingle,
  };
  return useObject(params);
}

export function useInspectionErrandRatings(filterMethod) {
  const params = {
    storeName: constants.STORE_NAME,
    filterMethod: filterMethod,
    fetchMethod: getAll,
  };
  return useObjects(params);
}

export function useFilteredInspectionErrandRatings(querystring) {
  const params = {
    storeName: constants.STORE_NAME,
    fetchMethod: performFilter,
    querystring: querystring,
  };

  return useFilteredObjects(params);
}

export function useInspectionErrandRatingsPagination(querystring) {
  const params = {
    storeName: constants.STORE_NAME,
    fetchMethod: filterPagination,
    querystring: querystring,
  };

  return usePagination(params);
}

export function useInspectionErrandRatingsPaginationCount({
  status,
  realEstates,
}) {
  const queryString = buildQueryString({
    status: status,
    realestate_ids: realEstates,
    _page: 1,
    _page_size: 0,
  });

  const params = {
    storeName: constants.STORE_NAME,
    fetchMethod: filterPagination,
    querystring: queryString,
  };

  return usePaginationCount(params);
}
